(() => {
  if (window.CD13ReferenceSearch) return;
  const ROOT = () => window.Shopify?.routes?.root || '/';
  const SECTION = 'cd13-reference-index';
  let cache;

  const compact = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const referenceQuery = (value) => compact(value).replace(/^(?:ref|reference)(?=[a-z0-9])/, '');
  const unprefix = (value) => compact(value).replace(/^v767(?=\d)/, '');
  const isReference = (value) => {
    const query = referenceQuery(value);
    return /^\d{6,}$/.test(query) || /^v767\d{6,}$/.test(query);
  };

  const referenceScore = (value, query) => {
    const reference = compact(value);
    const requested = referenceQuery(query);
    const normalizedReference = unprefix(reference);
    const normalizedRequested = unprefix(requested);
    if (!reference || !requested) return 0;
    if (reference === requested || normalizedReference === normalizedRequested) return 100;
    if (reference.startsWith(requested) || normalizedReference.startsWith(normalizedRequested)) return 70;
    if (reference.includes(requested) || normalizedReference.includes(normalizedRequested)) return 40;
    return 0;
  };

  async function page(number) {
    const url = new URL(ROOT(), location.origin);
    url.searchParams.set('section_id', SECTION);
    url.searchParams.set('page', number);
    const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Index indisponible');
    const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    const source = documentFragment.querySelector('[data-cd13-reference-index]');
    if (!source) throw new Error('Index absent');
    return JSON.parse(source.textContent || '{}');
  }

  async function index() {
    if (cache) return cache;
    cache = (async () => {
      const first = await page(1);
      const chunks = [first.products || []];
      for (let current = 2; current <= (Number(first.pages) || 1); current += 1) {
        const next = await page(current);
        chunks.push(next.products || []);
      }
      return chunks.flat();
    })();
    cache.catch(() => { cache = null; });
    return cache;
  }

  async function find(query) {
    if (!isReference(query)) return null;
    const matches = [];
    (await index()).forEach((product) => (product.variants || []).forEach((variant) => {
      const score = Math.max(0, ...[variant.sku, variant.supplierReference, variant.nationalReference]
        .map((value) => referenceScore(value, query)));
      if (score) matches.push({ product, variant, score });
    }));
    matches.sort((left, right) => right.score - left.score);
    if (!matches.length || (matches[1] && matches[0].score === matches[1].score)) return null;
    return matches[0];
  }

  const target = ({ product, variant }) => {
    const url = new URL(product.url, location.origin);
    if (variant.id) url.searchParams.set('variant', variant.id);
    return url.pathname + url.search;
  };

  const escapeHTML = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;' }[character]));

  function addExactResult(form, match) {
    const panel = form.querySelector('[data-cd13-search-results]');
    if (!panel || panel.querySelector('[data-cd13-reference-exact]')) return;
    const reference = match.variant.supplierReference || match.variant.sku || match.variant.nationalReference || '';
    const image = match.product.image ? '<img class="cd13-search-result__image" src="' + escapeHTML(match.product.image) + '" alt="">' : '<span class="cd13-search-result__image cd13-search-result__image--empty"></span>';
    panel.insertAdjacentHTML('afterbegin', '<section class="cd13-search-group" data-cd13-reference-exact><h3 class="cd13-search-group__title">Référence exacte</h3><div class="cd13-search-group__items"><a class="cd13-search-result cd13-search-result--product" href="' + escapeHTML(target(match)) + '">' + image + '<span class="cd13-search-result__body"><span class="cd13-search-result__title">' + escapeHTML(match.product.title) + '</span><span class="cd13-search-result__meta">Réf. ' + escapeHTML(reference) + '</span></span></a></div></section>');
    panel.hidden = false;
  }

  function attach(form) {
    const input = form.querySelector('input[name="q"]');
    const panel = form.querySelector('[data-cd13-search-results]');
    if (!input) return;
    let timer;
    let exact = null;
    const apply = () => exact && input.value.trim() === exact.query && addExactResult(form, exact.match);
    if (panel && window.MutationObserver) new MutationObserver(apply).observe(panel, { childList: true });

    input.addEventListener('input', () => {
      clearTimeout(timer); exact = null;
      const query = input.value.trim();
      if (!isReference(query)) return;
      timer = setTimeout(async () => {
        try {
          const match = await find(query);
          if (match && input.value.trim() === query) { exact = { query, match }; apply(); }
        } catch (_) {}
      }, 260);
    });

    form.addEventListener('submit', async (event) => {
      const query = input.value.trim();
      if (!isReference(query)) return;
      event.preventDefault();
      try {
        const match = await find(query);
        if (match) return location.assign(target(match));
      } catch (_) {}
      HTMLFormElement.prototype.submit.call(form);
    }, true);
  }

  function initialise() {
    document.querySelectorAll('[data-cd13-search], .cd13-search-page-form').forEach(attach);
    if (location.pathname !== '/search') return;
    const query = new URLSearchParams(location.search).get('q') || '';
    if (!isReference(query)) return;
    find(query).then((match) => { if (match) location.replace(target(match)); }).catch(() => {});
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initialise) : initialise();
  window.CD13ReferenceSearch = { find, isReference };
})();